<template>
  <div class="login-fade">
    <p class="login-title">
      <template v-if="step === 0">Sign Up</template>
      <template v-else>Just a few more details</template>
    </p>
    <div class="login">
      <button @click="signUpClose" class="login-close">
        <svg
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.00342 2L20.6685 20.6651"
            stroke="black"
            stroke-width="3"
            stroke-linecap="round"
          />
          <path
            d="M20.665 2L1.99993 20.6651"
            stroke="black"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </button>
      <div class="login-form">
        <div v-if="invited && inviter" class="inviter">
          <img
            v-if="inviter.profile_image"
            :src="inviter.profile_image.url"
            alt="Inviter"
            width="49"
            height="49"
            loading="lazy"
          />
          <p class="inviter-description">
            {{ inviter.full_name }} has invited you to Pixchange!
          </p>
        </div>
        <form id="sign-form" @submit="submitForm($event)">
          <template v-if="step === 1">
            <div class="input-wrapper">
              <svg
                class="input-icon"
                width="15"
                height="18"
                viewBox="0 0 15 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.49981 9.61661C9.55178 9.61661 11.2211 7.57516 11.2211 5.06578C11.2211 2.67411 9.69072 1.00391 7.49981 1.00391C5.3087 1.00391 3.77836 2.67411 3.77836 5.06578C3.77836 7.57516 5.44764 9.61661 7.49981 9.61661ZM7.49981 2.27495C8.98466 2.27495 9.982 3.39661 9.982 5.06557C9.982 6.87391 8.86847 8.34536 7.49981 8.34536C6.13116 8.34536 5.01763 6.87391 5.01763 5.06557C5.01763 3.39661 6.01517 2.27495 7.49981 2.27495ZM7.11895 11.0402H7.88047C11.4896 11.0402 13.9139 13.1785 13.9137 16.361C13.9137 16.7118 13.6364 16.9962 13.2944 16.9962C12.9519 16.9962 12.6746 16.7118 12.6746 16.361C12.6746 13.3718 10.0919 12.3114 7.88047 12.3114H7.11875C4.90733 12.3114 2.3252 13.3716 2.3252 16.361C2.3252 16.7118 2.04773 16.9962 1.70547 16.9962C1.36341 16.9962 1.08594 16.7118 1.08594 16.361C1.08594 13.1787 3.51044 11.0402 7.11895 11.0402Z"
                  fill="#6F96D7"
                />
                <path
                  d="M13.9137 16.361L13.7137 16.361V16.361H13.9137ZM11.0211 5.06578C11.0211 7.50421 9.40557 9.41661 7.49981 9.41661V9.81661C9.69799 9.81661 11.4211 7.6461 11.4211 5.06578H11.0211ZM7.49981 1.20391C8.5418 1.20391 9.41772 1.5998 10.0346 2.27307C10.6526 2.94763 11.0211 3.91264 11.0211 5.06578H11.4211C11.4211 3.82726 11.0244 2.76132 10.3295 2.00286C9.63343 1.24312 8.64873 0.803906 7.49981 0.803906V1.20391ZM3.97836 5.06578C3.97836 3.91264 4.34685 2.94764 4.96488 2.27308C5.58174 1.5998 6.45772 1.20391 7.49981 1.20391V0.803906C6.35079 0.803906 5.36605 1.24311 4.66996 2.00286C3.97504 2.76132 3.57836 3.82726 3.57836 5.06578H3.97836ZM7.49981 9.41661C5.59384 9.41661 3.97836 7.50421 3.97836 5.06578H3.57836C3.57836 7.64611 5.30144 9.81661 7.49981 9.81661V9.41661ZM10.182 5.06557C10.182 4.19182 9.9206 3.44381 9.44717 2.91149C8.9719 2.37711 8.29567 2.07495 7.49981 2.07495V2.47495C8.18879 2.47495 8.75366 2.73362 9.14828 3.17732C9.54472 3.62307 9.782 4.27037 9.782 5.06557H10.182ZM7.49981 8.54536C8.26063 8.54536 8.93558 8.13596 9.41363 7.50429C9.89165 6.87265 10.182 6.0094 10.182 5.06557H9.782C9.782 5.93008 9.51558 6.70673 9.09467 7.2629C8.67379 7.81904 8.10765 8.14536 7.49981 8.14536V8.54536ZM4.81763 5.06557C4.81763 6.0094 5.10797 6.87265 5.58599 7.50429C6.06404 8.13596 6.73899 8.54536 7.49981 8.54536V8.14536C6.89198 8.14536 6.32583 7.81904 5.90495 7.2629C5.48404 6.70673 5.21763 5.93008 5.21763 5.06557H4.81763ZM7.49981 2.07495C6.70405 2.07495 6.02782 2.37712 5.55254 2.91148C5.07908 3.4438 4.81763 4.19181 4.81763 5.06557H5.21763C5.21763 4.27038 5.45495 3.62308 5.85142 3.17732C6.24607 2.73361 6.81094 2.47495 7.49981 2.47495V2.07495ZM7.88047 10.8402H7.11895V11.2402H7.88047V10.8402ZM14.1137 16.361C14.1138 14.7157 13.4856 13.3297 12.3829 12.3571C11.2824 11.3865 9.72387 10.8402 7.88047 10.8402V11.2402C9.64619 11.2402 11.1044 11.7629 12.1183 12.6571C13.13 13.5494 13.7138 14.8238 13.7137 16.361L14.1137 16.361ZM13.2944 17.1962C13.7516 17.1962 14.1137 16.8175 14.1137 16.361H13.7137C13.7137 16.6062 13.5212 16.7962 13.2944 16.7962V17.1962ZM12.4746 16.361C12.4746 16.8176 12.8368 17.1962 13.2944 17.1962V16.7962C13.067 16.7962 12.8746 16.6061 12.8746 16.361H12.4746ZM7.88047 12.5114C8.95884 12.5114 10.1138 12.7707 10.9929 13.3797C11.8628 13.9822 12.4746 14.934 12.4746 16.361H12.8746C12.8746 14.7988 12.1951 13.7258 11.2207 13.0509C10.2556 12.3823 9.01352 12.1114 7.88047 12.1114V12.5114ZM7.11875 12.5114H7.88047V12.1114H7.11875V12.5114ZM2.5252 16.361C2.5252 14.9339 3.13691 13.9821 4.00659 13.3796C4.88557 12.7706 6.04038 12.5114 7.11875 12.5114V12.1114C5.9857 12.1114 4.74374 12.3823 3.7788 13.0508C2.80456 13.7257 2.1252 14.7987 2.1252 16.361H2.5252ZM1.70547 17.1962C2.16281 17.1962 2.5252 16.8176 2.5252 16.361H2.1252C2.1252 16.606 1.93266 16.7962 1.70547 16.7962V17.1962ZM0.885937 16.361C0.885937 16.8176 1.24829 17.1962 1.70547 17.1962V16.7962C1.47852 16.7962 1.28594 16.6061 1.28594 16.361H0.885937ZM7.11895 10.8402C5.27585 10.8402 3.71746 11.3866 2.61696 12.3572C1.51426 13.3298 0.885937 14.7158 0.885937 16.361H1.28594C1.28594 14.8239 1.86987 13.5495 2.88154 12.6572C3.89542 11.763 5.35355 11.2402 7.11895 11.2402V10.8402Z"
                  fill="#6F96D7"
                />
              </svg>
              <input
                class="input"
                type="text"
                name=""
                v-model="username"
                placeholder="Username"
                @change="changeUsername"
              />
            </div>
            <p v-if="invalidUsername.length" class="error-message">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.00146 2L9.99992 9.99845"
                  stroke="#CE0000"
                  stroke-width="3"
                  stroke-linecap="round"
                />
                <path
                  d="M9.99854 2L2.00008 9.99845"
                  stroke="#CE0000"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
              {{ invalidUsername }}
            </p>
            <div class="input-wrapper">
              <svg
                class="input-icon"
                width="15"
                height="18"
                viewBox="0 0 15 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.49981 9.61661C9.55178 9.61661 11.2211 7.57516 11.2211 5.06578C11.2211 2.67411 9.69072 1.00391 7.49981 1.00391C5.3087 1.00391 3.77836 2.67411 3.77836 5.06578C3.77836 7.57516 5.44764 9.61661 7.49981 9.61661ZM7.49981 2.27495C8.98466 2.27495 9.982 3.39661 9.982 5.06557C9.982 6.87391 8.86847 8.34536 7.49981 8.34536C6.13116 8.34536 5.01763 6.87391 5.01763 5.06557C5.01763 3.39661 6.01517 2.27495 7.49981 2.27495ZM7.11895 11.0402H7.88047C11.4896 11.0402 13.9139 13.1785 13.9137 16.361C13.9137 16.7118 13.6364 16.9962 13.2944 16.9962C12.9519 16.9962 12.6746 16.7118 12.6746 16.361C12.6746 13.3718 10.0919 12.3114 7.88047 12.3114H7.11875C4.90733 12.3114 2.3252 13.3716 2.3252 16.361C2.3252 16.7118 2.04773 16.9962 1.70547 16.9962C1.36341 16.9962 1.08594 16.7118 1.08594 16.361C1.08594 13.1787 3.51044 11.0402 7.11895 11.0402Z"
                  fill="#6F96D7"
                />
                <path
                  d="M13.9137 16.361L13.7137 16.361V16.361H13.9137ZM11.0211 5.06578C11.0211 7.50421 9.40557 9.41661 7.49981 9.41661V9.81661C9.69799 9.81661 11.4211 7.6461 11.4211 5.06578H11.0211ZM7.49981 1.20391C8.5418 1.20391 9.41772 1.5998 10.0346 2.27307C10.6526 2.94763 11.0211 3.91264 11.0211 5.06578H11.4211C11.4211 3.82726 11.0244 2.76132 10.3295 2.00286C9.63343 1.24312 8.64873 0.803906 7.49981 0.803906V1.20391ZM3.97836 5.06578C3.97836 3.91264 4.34685 2.94764 4.96488 2.27308C5.58174 1.5998 6.45772 1.20391 7.49981 1.20391V0.803906C6.35079 0.803906 5.36605 1.24311 4.66996 2.00286C3.97504 2.76132 3.57836 3.82726 3.57836 5.06578H3.97836ZM7.49981 9.41661C5.59384 9.41661 3.97836 7.50421 3.97836 5.06578H3.57836C3.57836 7.64611 5.30144 9.81661 7.49981 9.81661V9.41661ZM10.182 5.06557C10.182 4.19182 9.9206 3.44381 9.44717 2.91149C8.9719 2.37711 8.29567 2.07495 7.49981 2.07495V2.47495C8.18879 2.47495 8.75366 2.73362 9.14828 3.17732C9.54472 3.62307 9.782 4.27037 9.782 5.06557H10.182ZM7.49981 8.54536C8.26063 8.54536 8.93558 8.13596 9.41363 7.50429C9.89165 6.87265 10.182 6.0094 10.182 5.06557H9.782C9.782 5.93008 9.51558 6.70673 9.09467 7.2629C8.67379 7.81904 8.10765 8.14536 7.49981 8.14536V8.54536ZM4.81763 5.06557C4.81763 6.0094 5.10797 6.87265 5.58599 7.50429C6.06404 8.13596 6.73899 8.54536 7.49981 8.54536V8.14536C6.89198 8.14536 6.32583 7.81904 5.90495 7.2629C5.48404 6.70673 5.21763 5.93008 5.21763 5.06557H4.81763ZM7.49981 2.07495C6.70405 2.07495 6.02782 2.37712 5.55254 2.91148C5.07908 3.4438 4.81763 4.19181 4.81763 5.06557H5.21763C5.21763 4.27038 5.45495 3.62308 5.85142 3.17732C6.24607 2.73361 6.81094 2.47495 7.49981 2.47495V2.07495ZM7.88047 10.8402H7.11895V11.2402H7.88047V10.8402ZM14.1137 16.361C14.1138 14.7157 13.4856 13.3297 12.3829 12.3571C11.2824 11.3865 9.72387 10.8402 7.88047 10.8402V11.2402C9.64619 11.2402 11.1044 11.7629 12.1183 12.6571C13.13 13.5494 13.7138 14.8238 13.7137 16.361L14.1137 16.361ZM13.2944 17.1962C13.7516 17.1962 14.1137 16.8175 14.1137 16.361H13.7137C13.7137 16.6062 13.5212 16.7962 13.2944 16.7962V17.1962ZM12.4746 16.361C12.4746 16.8176 12.8368 17.1962 13.2944 17.1962V16.7962C13.067 16.7962 12.8746 16.6061 12.8746 16.361H12.4746ZM7.88047 12.5114C8.95884 12.5114 10.1138 12.7707 10.9929 13.3797C11.8628 13.9822 12.4746 14.934 12.4746 16.361H12.8746C12.8746 14.7988 12.1951 13.7258 11.2207 13.0509C10.2556 12.3823 9.01352 12.1114 7.88047 12.1114V12.5114ZM7.11875 12.5114H7.88047V12.1114H7.11875V12.5114ZM2.5252 16.361C2.5252 14.9339 3.13691 13.9821 4.00659 13.3796C4.88557 12.7706 6.04038 12.5114 7.11875 12.5114V12.1114C5.9857 12.1114 4.74374 12.3823 3.7788 13.0508C2.80456 13.7257 2.1252 14.7987 2.1252 16.361H2.5252ZM1.70547 17.1962C2.16281 17.1962 2.5252 16.8176 2.5252 16.361H2.1252C2.1252 16.606 1.93266 16.7962 1.70547 16.7962V17.1962ZM0.885937 16.361C0.885937 16.8176 1.24829 17.1962 1.70547 17.1962V16.7962C1.47852 16.7962 1.28594 16.6061 1.28594 16.361H0.885937ZM7.11895 10.8402C5.27585 10.8402 3.71746 11.3866 2.61696 12.3572C1.51426 13.3298 0.885937 14.7158 0.885937 16.361H1.28594C1.28594 14.8239 1.86987 13.5495 2.88154 12.6572C3.89542 11.763 5.35355 11.2402 7.11895 11.2402V10.8402Z"
                  fill="#6F96D7"
                />
              </svg>
              <input
                class="input"
                type="text"
                name=""
                v-model="fullname"
                placeholder="Full name"
                @change="changeFullname"
              />
            </div>
            <p v-if="invalidFullname.length" class="error-message">
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.00146 2L9.99992 9.99845"
                  stroke="#CE0000"
                  stroke-width="3"
                  stroke-linecap="round"
                />
                <path
                  d="M9.99854 2L2.00008 9.99845"
                  stroke="#CE0000"
                  stroke-width="3"
                  stroke-linecap="round"
                />
              </svg>
              {{ invalidFullname }}
            </p>
          </template>
          <div class="input-wrapper">
            <svg
              class="input-icon"
              width="15"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.4615 12H14.5392C15.3452 12 15.9998 11.3628 16 10.581V1.41793C16 0.635655 15.3452 0 14.5394 0H1.4615C0.654828 0 0 0.635655 0 1.41793V10.581C0 11.3628 0.654828 12 1.4615 12ZM1.4615 1.42811L14.5277 1.41811H14.5278V10.5717L1.47145 10.5812L1.4615 1.42811Z"
                fill="#6F96D7"
              />
              <path
                d="M7.99907 8C7.83687 8 7.67467 7.94124 7.54241 7.82567L1.25092 2.30059C0.952869 2.03722 0.9142 1.57316 1.16794 1.26278C1.41997 0.950436 1.86602 0.910904 2.16493 1.17445L7.99924 6.29993L13.8344 1.17445C14.1343 0.911082 14.5795 0.950436 14.8324 1.26278C15.0853 1.57316 15.0475 2.03722 14.7493 2.30059L8.45556 7.82567C8.32347 7.94124 8.16127 8 7.99907 8Z"
                fill="#6F96D7"
              />
            </svg>
            <input
              v-model="email"
              class="input"
              type="email"
              name=""
              placeholder="E-mail"
              @change="changeEmail"
              :readonly="step === 1"
            />
          </div>
          <p v-if="invalidEmail.length" class="error-message">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.00146 2L9.99992 9.99845"
                stroke="#CE0000"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M9.99854 2L2.00008 9.99845"
                stroke="#CE0000"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
            {{ invalidEmail }}
          </p>
          <PasswordElemComponent
            v-if="step === 0"
            @change="changePassword($event)"
            v-model="password"
          />
          <p v-if="invalidPassword.length" class="error-message">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.00146 2L9.99992 9.99845"
                stroke="#CE0000"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M9.99854 2L2.00008 9.99845"
                stroke="#CE0000"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
            {{ invalidPassword }}
          </p>
          <p v-if="step === 0" class="password-crieteria">
            Password should contain: <br />
            <span :class="passwordCriteria.hasMinLenght ? 'green' : 'red'"
              >at least 8 characters</span
            >,
            <span :class="passwordCriteria.hasLowercase ? 'green' : 'red'"
              >1 lowercase letter</span
            >, <br />
            <span :class="passwordCriteria.hasUppercase ? 'green' : 'red'"
              >1 uppercase letter</span
            >, and
            <span :class="passwordCriteria.hasNumber ? 'green' : 'red'"
              >1 number</span
            >
          </p>
          <button
            v-if="step === 0"
            class="login-submit"
            name="button"
            @click.prevent="nextStep"
          >
            Sign up
          </button>
          <button
            v-else
            type="submit"
            class="login-submit"
            name="button"
            @click="submitForm($event)"
          >
            Sign up
          </button>
          <div v-if="step === 0" class="sign-up-terms">
            <div class="custom-checkbox">
              <input
                type="checkbox"
                class="custom-input"
                v-model="checkbox"
                @change="changePolicy"
              />
              <div class="custom-checkbox-inner"></div>
            </div>
            <p class="from-terms__text">
              By creating account I agree to the
              <br />
              <router-link to="/terms" target="_blank" class="link"
                >User Agreement</router-link
              >
              and
              <router-link to="/privacy-policy" target="_blank" class="link"
                >Privacy Policy</router-link
              >
            </p>
          </div>
          <p v-if="invalidPolicy.length" class="error-message">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.00146 2L9.99992 9.99845"
                stroke="#CE0000"
                stroke-width="3"
                stroke-linecap="round"
              />
              <path
                d="M9.99854 2L2.00008 9.99845"
                stroke="#CE0000"
                stroke-width="3"
                stroke-linecap="round"
              />
            </svg>
            {{ invalidPolicy }}
          </p>
          <div class="divider"><span class="divider-text">OR</span></div>

          <!-- <button class="btn-google">
            Sign In with Google
          </button> -->

          <!-- <button @click="fbSignUp($event)" class="btn-facebook">
            Sign Up with Facebook
          </button> -->
          <p class="sign-up">
            Already have an account?
            <span @click="backToLogin" class="sign-up-link">Sign In</span>
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordElemComponent from "./elems/form-password";

import appIds from "../../../config/apps";
import * as Facebook from "../../components/fbSdkWrapper";
import services from "../../../services";

const apiUrl = process.env.BASE_URL;
const appId = appIds[process.env.NODE_ENV];

export default {
  name: "SignUp",
  components: {
    PasswordElemComponent,
  },

  data() {
    return {
      invited: false,
      inviter: null,
      step: 0,
      checkbox: false,
      email: "",
      password: "",
      passwordFieldType: "password",
      username: "",
      fullname: "",
      invalidEmail: "",
      invalidPassword: "",
      invalidPolicy: "",
      invalidUsername: "",
      invalidFullname: "",
      passwordCriteria: {
        hasMinLenght: false,
        hasNumber: false,
        hasLowercase: false,
        hasUppercase: false,
      },
      token: "",
      apiUrl: process.env.BASE_URL,
    };
  },
  created() {
    Facebook.load().then(() => {
      Facebook.init({
        appId,
      });
    });
  },
  async mounted() {
    this.invited = Object.keys(this.$route.query)[0] === "user-invitation";

    if (this.invited) {
      this.inviter = await services.user.fetchUser(
        this.$route.query["user-invitation"]
      );
    }
  },
  watch: {
    password() {
      this.passwordCriteria.hasMinLenght = this.password.length >= 8;
      this.passwordCriteria.hasNumber = /\d/.test(this.password);
      this.passwordCriteria.hasLowercase = /[a-z]/.test(this.password);
      this.passwordCriteria.hasUppercase = /[A-Z]/.test(this.password);
    },
    email(value) {
      this.email = value;
    },
  },

  methods: {
    backToLogin() {
      this.$emit("backToLogin");
    },
    signUpClose() {
      this.$emit("signUpClose");
    },
    changePassword(e) {
      this.password = e;
      this.invalidPassword = "";
    },
    changeUsername() {
      this.invalidUsername = "";
    },
    changeFullname() {
      this.invalidFullname = "";
    },
    changeEmail() {
      this.invalidEmail = "";
    },
    changePolicy() {
      this.invalidPolicy = "";
    },
    fieldMatchCriteria(criteries) {
      return criteries.every((criteria) => criteria);
    },
    formHasRequiredFields(fields) {
      return fields.some((field) => field);
    },
    saveUserData(data) {
      this.$store.dispatch("auth/setUserData", data);
    },
    autoLogin(fd) {
      fd.append("session[email]", this.email);
      fd.append("session[password]", this.password);

      fetch(`${this.apiUrl}/api/auth/session`, {
        method: "POST",
        body: fd,
      })
        .then((resp) => {
          return resp.json();
        })
        .then((data) => {
          this.saveUserData(data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    fbSignUp(e) {
      e.preventDefault();
      const token = "";
      Facebook.login().then((response) => {
        if (response.status === "connected") {
          // logged in
          const fd = new FormData();
          fd.append("access_token", response.authResponse.accessToken);
          fd.append("terms_of_service", true);
          fetch(`${apiUrl}/api/auth/facebook/registrations`, {
            method: "POST",
            body: fd,
          })
            .then((resp) => {
              if (resp.status !== 422) {
                return resp.json();
              } else {
                return resp.json();
              }
            })
            .then((data) => {
              this.saveUserData(data);
              this.signUpClose();
              this.$router.replace("/profile");
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log(err);
        }
      });
    },
    nextStep() {
      const form = document.getElementById("sign-form");
      const fd = new FormData(form);

      fd.append("registration[email]", this.email);
      fd.append("registration[password]", this.password);
      fd.append("registration[terms_of_service]", this.checkbox);
      fd.append("registration[registration_source]", "5");

      fetch(`${this.apiUrl}/api/auth/registrations`, {
        method: "POST",
        body: fd,
      })
        .then((resp) => {
          return resp.json();
        })
        .then(async (data) => {
          const errors = await data["errors"];
          if (errors) {
            const emailError = errors.find(
              (item) => item.attribute === "email"
            );
            const passwordError = errors.find(
              (item) => item.attribute === "password"
            );
            const policyError = errors.find(
              (item) => item.attribute === "terms_of_service"
            );

            this.invalidEmail = emailError ? emailError.title : "";
            this.invalidPassword = passwordError ? passwordError.title : "";
            this.invalidPolicy = policyError ? policyError.title : "";
          } else {
            this.token = data["token"];
            this.invalidEmail = "";
            this.invalidPassword = "";
            this.invalidPolicy = "";
            this.step++;
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
        });
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    async submitForm(e) {
      e.preventDefault();
      let form = document.getElementById("sign-form");
      let fd = new FormData(form);

      fd.append("registration[email]", this.email);
      fd.append("registration[username]", this.username);
      fd.append("registration[full_name]", this.fullname);

      fetch(`${this.apiUrl}/api/auth/registrations`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
        body: fd,
      })
        .then((resp) => resp.json())
        .then(async (data) => {
          const errors = await data["errors"];
          if (errors) {
            errors.forEach((error) => {
              if (error.attribute === "username") {
                this.invalidUsername = error.title;
              } else {
                this.invalidFullname = error.title;
              }
            });
          } else {
            this.invalidUsername = "";
            this.invalidFullname = "";
            this.autoLogin(fd);
            this.$emit("welcome");
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
        });
    },
    cancel() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.inviter {
  margin-bottom: 44px;
  display: flex;
  align-items: center;

  line-height: 20px;
  letter-spacing: -0.256px;
  color: #3a4146;
}
.inviter img {
  margin-right: 21px;
  border-radius: 3px;
}
.login-title {
  margin-bottom: 56px;
  color: #1e2541;
  font-family: "SF Pro Display";
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
}

@media (max-width: 767px) {
  .login-title {
    font-size: 24px;
    line-height: 1;
  }
}

.login-fade {
  padding: 50px 20px;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(242, 242, 242, 0.85);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
}

@media (max-width: 991px) {
  .login-fade {
    padding-top: 100px;
  }
}

.login {
  position: relative;
  display: flex;
  justify-content: center;
  align-self: center;
  margin: 0 20px;
  padding: 58px 70px 52px;
  max-width: 456px;
  height: fit-content;
  width: 100%;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0px 4px 10px rgba(44, 145, 179, 0.3);
}

@media (max-width: 991px) {
  .login {
    padding: 58px 20px 52px;
  }
}

.login-form {
  width: 100%;
}

.login-close {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 19px;
  height: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
}

.input-wrapper {
  margin-bottom: 15px;
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  border: 1px solid #d1d8dd;
  border-radius: 35px;
  overflow: hidden;
  z-index: 1;
}

.input-icon {
  margin-left: 31px;
  position: relative;
  z-index: 1;
  pointer-events: none;
}

.input {
  padding: 17px 31px 17px 54px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  border: none;
  outline: none;
  color: #3a4146;
}

.input::placeholder {
  color: #3a4146;
}

.login-submit {
  display: block;
  margin: 36px auto 0;
  width: 100%;
  height: 50px;
  color: #fff;
  background: linear-gradient(315deg, #1f32c7 0%, #3cd1f3 100%);
  border-radius: 23px;
  border: none;
  font-family: SF Pro Display;
  font-style: normal;
  font-size: 16px;
  cursor: pointer;
}

.divider {
  margin: 44px auto 40px;
  max-width: 200px;
  position: relative;
  display: flex;
  justify-content: center;
}

.divider:after {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: #6f96d7;
}

.divider-text {
  width: 40px;
  display: flex;
  justify-content: center;
  font-family: "SF Pro Display";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #2969d6;
  background: #fff;
  position: relative;
  z-index: 1;
}

.sign-up {
  font-family: "SF Pro Display";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #757575;
  text-align: center;
}

.sign-up-link {
  color: #2969d6;
  cursor: pointer;
}

.sign-up-terms {
  margin: 26px 0 30px;
  display: flex;
  align-items: center;
}

.custom-checkbox {
  margin-right: 14px;
  position: relative;
  width: 28px;
  height: 28px;
  border: 2px solid #2969d6;
  border-radius: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.custom-input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 1;
  cursor: pointer;
}

.custom-checkbox-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.custom-input:checked + .custom-checkbox-inner:after {
  content: url("data:image/svg+xml,%3Csvg width='20' height='15' viewBox='0 0 20 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 1L6.625 13.4615L1 7.7972' fill='white'/%3E%3Cpath d='M19 1L6.625 13.4615L1 7.7972' stroke='%232c79db' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  position: absolute;
  top: 4px;
}

.from-terms__text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.3px;
  color: #6f96d7;
}

.link {
  color: #2551d0;
  text-decoration: none;
  font-weight: 500;
}

.password-crieteria {
  padding: 0 15px;
  font-family: "SF Pro Display";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #000;
}

.green {
  color: #13c16e;
}

.red {
  color: #e91111;
}
</style>
